var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 46,
    viewBox: "0 0 38 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.4706L22.1863 23L0 13.2588V0L38 17.5882V28.4118L0 46V32.4706Z",
    fill: "#8C2EC6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginNew);
export default __webpack_public_path__ + "static/media/LoginNew.b844b8e40ef91babc3bb8049b4237b2d.svg";
export { ForwardRef as ReactComponent };